// extracted by mini-css-extract-plugin
export default {"base":"vp_wboO1","symbol":"vp_DzQgB","label":"vp_ohvLS"};